// extracted by css-extract-rspack-plugin
export default {"cls1":"ContentFeedback-cls1_IFq","cls2":"ContentFeedback-cls2_jFE ContentFeedback-cls1_IFq"};